import { CerFormAdapter } from "@cer/cer-form/cer-form-adapter";
import { CerFormView } from "@cer/cer-form/cer-form-view";

export class VoucherValidationStatusForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'bilags-validerings-status', dataApiName: 'VoucherValidationStatus', text: 'Valideringsstatus',
        primaryKey: 'id', baseFields: ['id', 'name', 'history']
      }
    });
  }
}
